// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nDfc","content":"styles_content__uzcUX","row":"styles_row__2uh4q","footer":"styles_footer__1X4SV","phraseLength":"styles_phraseLength__2N6km"};